/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - sutik naujų žmonių, kalbėkis, bendrauk",
      "Neteisingas telefono numeris",
      "Get the app",
      "Tęsti su Apple",
      "Tęsti su „Facebook“",
      "Tęsti su „Google“",
      "Prisijungti",
      "Užsiregistruoti",
      "Norint tęsti, įveskite simbolius, kuriuos matote įvesties lauke.",
      "Tęsti",
      "Įvesti simbolius",
      "Saugos patikra",
      "Perkrauti",
      "Sukurkite slaptažodį, kurį lengvai prisiminsite:",
      "Atnaujinti",
      "Patvirtinti slaptažodį",
      "Slaptažodį turi sudaryti bent {{num}} [[characters:num]]",
      "Slaptažodis",
      "Sukurti naują slaptažodį",
      "Badoo - tinklaraštis",
      "Karjera",
      "Pokalbis",
      "Miestai",
      "Tvarkyti slapukus",
      "Copyright © 2006 – einamuoju laiku. Bumble. Visos teisės saugomos.",
      "Apple ir the Apple logo yra prekiniai Apple Inc. ženklai{{__EOL__}}Google Play yra Google LLC prekinis ženklas.",
      "Atsisiųsti",
      "Facebook",
      "Sekite mus",
      "Pagalbos centras",
      "Instagram",
      "Kalba",
      "LinkedIn",
      "Peržiūra",
      "Badoo yra Bumble Inc.",
      "Privatumo politika",
      "Safety Centre",
      "Tinklapio schema",
      "Modernios vergystės aktas",
      "Taisyklės ir sąlygos",
      "Twitter",
      "Įveskite savo el. paštą ar mobilųjį numerį ir mes nusiųsime intrukcijas naujam slaptažodžio sukūrimui.",
      "Gaukite naują slaptažodį",
      "Įveskite el. paštą ar telefono numerį",
      "Pamirštas slaptažodis",
      "Modeliai naudojami tik vizualiniais tikslais",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "Nebūtina laukti atitikimo.{{__EOL__}}{{__EOL__}}Pasinerk į gilesnius pokalbius ir eik prie svarbių dalykų. Prie tų, kurie iš tikrųjų padeda geriau pažinti.",
      "Pasiruošei pokalbiams?",
      "Registruojantis sutinkate su mūsų <a class=\"link\" href=\"{{terms_url}}\">Taisyklėmis ir sąlygomis</a>. Sužinokite, kaip naudojame jūsų duomenis <a class=\"link\" href=\"{{privacy_url}}\">Privatumo politikoje</a>",
      "Padeda daugiau realizuoti save <br /> pasimatymuose, kuriuose jautiesi gerai.",
      "Viskas patikimoms pažintims",
      "arba",
      "Jau turite paskyrą?",
      "Užsiregistruokite el. paštu ir telefono numeriu",
      "Gauk ko nori iš pasimatymų.{{__EOL__}}Be apgailestavimų.",
      "Nori tik kalbėtis? Puiku!{{__EOL__}}Nori stabilumo? Miela!{{__EOL__}}{{__EOL__}}Ir bet kada gali pakeisti savo nuomonę.",
      "Domina pasimatymai",
      "Domina santykiai",
      "Laukiu pokalbių",
      "Sutik to paties norinčių žmonių.",
      "{{name}}, {{age}}",
      "Jūsų saugumas mūsų prioritetas.",
      "Mūsų Safety Centre, tai žinių bankas, kuriame rasi visą pagalbą saugiems pasimatymams.",
      "Apsilankyk mūsų Safety Centre",
      "Saugumas pirmiausia<br/>, visą kitą - po to.",
      "Nuo pirmos akimirkos žinojau, kad tai veiks...",
      "Iš pradžių neiškojau nieko rimto…",
      "Geriausias patarimas bet kam Badoo programėlėje: būti savimi",
      "Badoo sėkmės istorijos",
      "Peržiūrėk daugiau istorijų",
      "{{num}}__CUT__Reitingas",
      "Apple App parduotuvė",
      "Pasitikėk mumis. Nuo 2006 m. suvedėme milijonus (ir milijonų milijonus) žmonių kartu.",
      "{{num}}M+__CUT__Atsisiuntimai",
      "{{num}}M+",
      "Google Play parduotuvė",
      "Mes žinome, ką darome.",
      "Prisijunkite su el. paštu ar telefono numeriu",
      "Įvesti slaptažodį",
      "Pamiršote slaptažodį?",
      "Užsiregistruoti",
      "Neturite paskyros?",
      "Prisijungti",
      "Užsiregistruoti"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "few": [
                  "simboliai",
                  "simbolių",
                  "simboliams",
                  "simbolius",
                  "simboliuose",
                  "simboliais",
                  "simboliai!"
            ],
            "plural": [
                  "simbolių",
                  "simbolių",
                  "simbolių",
                  "simbolių",
                  "simbolių",
                  "simbolių",
                  "simbolių!"
            ],
            "singular": [
                  "simbolis",
                  "simbolio",
                  "simboliui",
                  "simbolį",
                  "simbolyje",
                  "simboliu",
                  "simbolis!"
            ]
      },
      "day": {
            "few": [
                  "dienos",
                  "dienų",
                  "dienoms",
                  "dienas",
                  "dienose",
                  "dienomis",
                  "dienos!"
            ],
            "plural": [
                  "dienų",
                  "dienų",
                  "dienų",
                  "dienų",
                  "dienų",
                  "dienų",
                  "dienų!"
            ],
            "singular": [
                  "diena",
                  "dienos",
                  "dienai",
                  "dieną",
                  "dienoje",
                  "diena",
                  "diena!"
            ]
      },
      "hour": {
            "few": [
                  "valandos",
                  "valandų",
                  "valandoms",
                  "valandas",
                  "valandose",
                  "valandomis",
                  "valandos!"
            ],
            "plural": [
                  "valandų",
                  "valandų",
                  "valandų",
                  "valandų",
                  "valandų",
                  "valandų",
                  "valandų!"
            ],
            "singular": [
                  "valanda",
                  "valandos",
                  "valandai",
                  "valandą",
                  "valandoje",
                  "valanda",
                  "valanda!"
            ]
      },
      "minute": {
            "few": [
                  "minutės",
                  "minučių",
                  "minutėms",
                  "minutes",
                  "minutėse",
                  "minutėmis",
                  "minutės!"
            ],
            "plural": [
                  "minučių",
                  "minučių",
                  "minučių",
                  "minučių",
                  "minučių",
                  "minučių",
                  "minučių!"
            ],
            "singular": [
                  "minutė",
                  "minutės",
                  "minutei",
                  "minutę",
                  "minutėje",
                  "minute",
                  "minute!"
            ]
      },
      "month": {
            "few": [
                  "mėnesiai",
                  "mėnesių",
                  "mėnesiams",
                  "mėnesius",
                  "mėnesiuose",
                  "mėnesiais",
                  "mėnesiai!"
            ],
            "plural": [
                  "mėnesių",
                  "mėnesių",
                  "mėnesių",
                  "mėnesių",
                  "mėnesių",
                  "mėnesių",
                  "mėnesių!"
            ],
            "singular": [
                  "mėnuo",
                  "mėnesio",
                  "mėnesiui",
                  "mėnesį",
                  "mėnesyje",
                  "mėnesiu",
                  "mėnesi!"
            ]
      },
      "second": {
            "few": [
                  "sekundės",
                  "sekundžių",
                  "sekundėms",
                  "sekundes",
                  "sekundėse",
                  "sekunde",
                  "sekundės!"
            ],
            "plural": [
                  "sekundžių",
                  "sekundžių",
                  "sekundžių",
                  "sekundžių",
                  "sekundžių",
                  "sekundžių",
                  "sekundžių!"
            ],
            "singular": [
                  "sekundė",
                  "sekundės",
                  "sekundei",
                  "sekundę",
                  "sekundėje",
                  "sekunde",
                  "sekunde!"
            ]
      },
      "year": {
            "few": [
                  "metai",
                  "metų",
                  "metams",
                  "metus",
                  "metuose",
                  "metais",
                  "metai!"
            ],
            "plural": [
                  "metų",
                  "metų",
                  "metų",
                  "metų",
                  "metų",
                  "metų",
                  "metų!"
            ],
            "singular": [
                  "metai",
                  "metų",
                  "metams",
                  "metus",
                  "metuose",
                  "metais",
                  "metai!"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
